/**
 * Single source of truth for Fedevo 2.0 social media handles.
 * Edit here if any account URL ever changes.
 */
export const SOCIAL = {
  facebook: {
    url: "https://www.facebook.com/profile.php?id=61559571578202",
    label: "Facebook · Fedevo 2.0",
  },
  // Add others later (instagram, youtube, tiktok...)
};

/** Facebook Page Plugin iframe URL builder. Plugin is free and requires no API key. */
export const buildFacebookPagePluginUrl = ({
  href,
  width = 500,
  height = 500,
  tabs = "timeline",
  smallHeader = true,
  hideCover = false,
  showFacepile = true,
}) => {
  const params = new URLSearchParams({
    href,
    tabs,
    width: String(width),
    height: String(height),
    small_header: String(smallHeader),
    adapt_container_width: "true",
    hide_cover: String(hideCover),
    show_facepile: String(showFacepile),
    appId: "",
  });
  return `https://www.facebook.com/plugins/page.php?${params.toString()}`;
};
